'use strict';
import React from 'react';
import {Component} from 'react';
import {observer} from 'mobx-react';

import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import Snackbar from 'material-ui/Snackbar';
import CircularProgress from 'material-ui/CircularProgress';

import apiRequest from '../lib/api-request';

import { ValidatorForm, TextValidator} from 'react-material-ui-form-validator';


const styles = {
  textField: {
  }
}

@observer(['state','actions'])
export default class Login extends Component {

  constructor(props) {
    super(props)

    this.state = {
      email: '',
      passwird: '',
      loading: false,
      snackbarOpen: false,
      snackbarMessage: ''
    }
  }

  componentWillMount() {

    document.body.style.backgroundColor = "#fff";
  }

  snackbar(message, type = 'default') {

    let color = 'rgba(0, 0, 0, 0.87)'

    if (type == 'warning') {
      color = '#FF5722'
    }
    else if (type == 'danger') {
      color = '#F44336'
    }

    this.setState({
      snackbarOpen: true,
      snackbarMessage: message,
      snackbarColor: color
    })
  }

  login() {

    let self = this

    let email = this.state.email
    let password = this.state.password

    if (!email || !password) {
      self.snackbar("Please enter a valid email and password", 'danger')
      return
    }

    this.setState({ loading: true })

    this.props.actions.auth.old_login({
      email,
      password,
      method: 1,
      remember_me: false
    }).then(
      (res) => {

        console.log("Login success", res);
        var origin = window.location.protocol + "//" + window.location.host;
        if (window.location.hostname.indexOf('.local') > -1) {
          window.location.assign('http://tipigo.local/app/dist/index.html#/');
        }
        else {
          window.location.assign(origin + '/app/dist/index.html#/');
        }
        self.setState({ loading: false })
      },
      (err) => {
        self.snackbar("Login failed. Please check your email and password and try again", 'danger')
        console.log("Login error:", err);
        self.setState({ loading: false })
      })

  }

  render() {
      return (
        <div>
          <div className="container" style={{
              margin: 40,
              marginTop: 100
            }}>
            <ValidatorForm
              ref="form"
              onSubmit={() => {}}
              onError={errors => console.log(errors)}>
              <div className="row">
                <div className="col-sm-offset-2 col-sm-4">
                  <div className="row">
                    <div className="col-sm-12">
                      <img
                        style={{maxWidth: 120, marginLeft: -7}}
                        src={require('../../img/tipigo-logo.png')} />

                    
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-12">
                      <TextValidator
                        disabled={this.state.loading}
                        name="email-input"
                        style={styles.textField}
                        hintText="Please enter your email"
                        underlineFocusStyle={{"borderColor":"#47b927"}}
                        value={this.state.email}
                        onChange={(event) => this.setState({ email: event.target.value })}
                        validators={['required', 'isEmail']}
                        errorMessages={['this field is required', 'email is not valid']}
                        floatingLabelText="Email"/>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-12">
                      <TextValidator
                        disabled={this.state.loading}
                        name="password-input"
                        type="password"
                        style={styles.textField}
                        hintText="Please enter your password"
                        underlineFocusStyle={{"borderColor":"#47b927"}}
                        value={this.state.password}
                        onChange={(event) => this.setState({ password: event.target.value })}
                        validators={['required']}
                        errorMessages={['this field is required']}
                        floatingLabelText="Password"/>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-sm-12">
                      {
                        this.state.loading ?
                        <CircularProgress size={24} style={{margin: 14}} /> :
                          <RaisedButton
                            disabled={this.state.loading}
                            onTouchTap={this.login.bind(this)}
                            label="Login" primary={true} style={{margin: 12}} />
                      }

                    </div>
                  </div>


                </div>
                <div className="col-sm-6">
                  <img
                    style={{width: '100%'}}
                    src={require('../../img/bird-ai.png')} />
                </div>
              </div>
            </ValidatorForm>

          </div>
          <div style={{
              position: 'fixed',
              height: 60,
              width: '100%',
              textAlign: 'center',
              color: '#aaa',
              fontSize: 12
            }}>
            Tipigo &copy; 2017
          </div>

          <Snackbar
            open={this.state.snackbarOpen}
            message={this.state.snackbarMessage}
            bodyStyle={{backgroundColor: this.state.snackbarColor}}
            autoHideDuration={4000}
            onRequestClose={this.handleRequestClose}
          />
        </div>

      )
  }
}



// WEBPACK FOOTER //
// ./src/js/pages/Login.js